import axios from '@/utils/request'

export default {
	async login(data) {
		const res = await axios({
			method: 'post',
			url: '/user/login/930',
			data,
		})
		return res.data
	},
	async getRecommendPic(params) {
		const res = await axios({
			method: 'get',
			url: '/photo/photoPage',
			params,
		})
		return res.data
	},
	async heal(params) {
		const res = await axios({
			method: 'get',
			url: '/health/check',
			params,
		})
		return res.data
	},
	async getUserPic(params) {
		const res = await axios({
			method: 'get',
			url: '/user/userPhotoPage',
			params,
		})
		return res.data
	},
	async getUserInfo(params) {
		const res = await axios({
			method: 'get',
			url: '/user/info',
			params,
		})
		return res.data
	},
	async logout(params) {
		const res = await axios({
			method: 'get',
			url: '/user/logout',
			params,
		})
		return res.code
	},
	async myPicDetail(params) {
		const res = await axios({
			method: 'get',
			url: '/user/photoInfo',
			params,
		})
		return res
	},
	async requestPaint(data) {
		const res = await axios({
			method: 'post',
			url: '/plant/plantPhoto',
			data,
		})
		return res
	},
	async checkTask(data) {
		const res = await axios({
			method: 'post',
			url: '/plant/checkTaskType',
			data,
		})
		return res
	},
}
